<script>
import InputDouble from '@/components(new)/UI/Forms/InputDouble/InputDouble.vue'
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import IlpfLavoura from '@/components(new)/UI/Forms/ILPF/IlpfLavoura'
import IlpfPecuaria from '@/components(new)/UI/Forms/ILPF/IlpfPecuaria'
import IlpfFloresta from '@/components(new)/UI/Forms/ILPF/IlpfFloresta'
import Bioinsumos from '@/components(new)/UI/Forms/FormulariosProntos/Bioinsumos/Bioinsumos.vue'
import Financiamentos from '@/components(new)/UI/Forms/FormulariosProntos/Financiamentos/Financiamentos.vue'
import Irrigacao from '@/components(new)/UI/Forms/FormulariosProntos/Irrigacao/Irrigacao.vue'

import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import { modalidades, culturas, tiposCriacao, especiesFlorestais, opcoesSimNao } from '@/libs/constants/praticas/opcoesSelects'

export default {
  mixins: [onlyInputNumbers],
  components: {
    InputDouble,
    TitleWithRow,
    Label,
    InputSelect,
    IlpfLavoura,
    IlpfPecuaria,
    IlpfFloresta,
    Bioinsumos,
    Financiamentos,
    Irrigacao
  },

  props: {
    nomeAba: {
      type: String,
      default: 'Práticas'
    },
    pratica: {
      required: true
    }
  },

  data () {
    return {
      modalidades: modalidades,
      culturas: culturas,
      tiposCriacao: tiposCriacao,
      especiesFlorestais: especiesFlorestais,
      opcoesSimNao: opcoesSimNao
    }
  },

  computed: {
    temLavoura () {
      return (
        Array.isArray(this.pratica.modalidades) &&
        this.pratica.modalidades.some(modalidades => modalidades.includes('LAVOURA'))
      )
    },
    temPecuaria () {
      return (
        Array.isArray(this.pratica.modalidades) &&
        this.pratica.modalidades.some(modalidades => modalidades.includes('PECUARIA'))
      )
    },
    temFloresta () {
      return (
        Array.isArray(this.pratica.modalidades) &&
        this.pratica.modalidades.some(modalidades => modalidades.includes('FLORESTA'))
      )
    }
  }
}
</script>

<template>
  <div>
    <el-row :gutter="20">
      <validation-provider rules="area" v-slot="{ errors }" :name="nomeAba + '/Área (ha)'">
        <el-col :span="6">
          <Label label="Área (ha) " :obrigatorio="true" />
          <InputDouble
            :class="{ erro: errors.length, input: 'input' }"
            name='Área (ha) '
            :precision="2"
            :onkeypress="onlyInputNumbers"
            :showAppend ="true"
            v-model="pratica.area"
          />
          <span class="help erro">{{ errors[0] }}</span>
        </el-col>
      </validation-provider>
      <validation-provider rules="required" v-slot="{ errors }" :name="nomeAba + '/Data de início (mês/ano)'">
        <el-col :span="6">
          <Label label="Data de início (mês/ano)" :obrigatorio="true" />
          <el-date-picker
            v-model="pratica.dataInicio"
            type="month"
            placeholder="Selecione mês e ano"
            format="MM/yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            :class="{ erro: errors.length, input: 'input' }"
          />
          <span class="help erro">{{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>
    <el-row :gutter="20">
      <validation-provider>
        <InputSelect
          :label="'Modalidade adotada'"
          :obrigatorio="true"
          rulesInput="required"
          :opcoes="modalidades"
          :multi-select="true"
          v-model="pratica.modalidades"
          :widthColumn="12"
        />
      </validation-provider>
    </el-row>

    <ilpf-lavoura
      v-if="temLavoura"
      :culturas="culturas"
      :pratica="pratica"
    />

    <ilpf-pecuaria
      v-if="temPecuaria"
      :tipos-criacao="tiposCriacao"
      :pratica="pratica"
    />

    <ilpf-floresta
      v-if="temFloresta"
      :especies-florestais="especiesFlorestais"
      :pratica="pratica"
    />

    <Bioinsumos :pratica="pratica" :nomeAba="nomeAba" />

    <Irrigacao :pratica="pratica" :nomeAba="nomeAba" />

    <Financiamentos :pratica="pratica" :nomeAba="nomeAba" />

    <TitleWithRow title="" />
    <el-row>
      <el-col :span="24">
        <Label
          label="Descrição"
        />
        <el-input
          name="Descrição"
          v-model="pratica.descricao"
          type="textarea"
          maxlength="500"
          show-word-limit
        />
      </el-col>
    </el-row>

  </div>
</template>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/ILPF/ILPF.vue